import React, { ComponentPropsWithoutRef } from 'react';
import { TextLink } from '@ovotech/element-v4';

type TextLinkProps = ComponentPropsWithoutRef<typeof TextLink>;

type PhoneLinkProps = TextLinkProps & {
  number: string;
};

export const PhoneLink = ({ number, ...other }: PhoneLinkProps) => {
  const href = `tel:${number.replace(/\s/g, '')}`;

  return (
    <TextLink href={href} {...other}>
      {number}
    </TextLink>
  );
};
